// extracted by mini-css-extract-plugin
export default {"otpWrapper":"OtpInputBox_otpWrapper__rszEr","otpVisual":"OtpInputBox_otpVisual__EKGmy","otpAutofillCapture":"OtpInputBox_otpAutofillCapture__7n6PJ"};